import { createWebHistory, createRouter } from "vue-router";
import AcreditacionFinalizada from "@/components/AcreditacionFinalizada.vue";
import NotFoundSection from "@/components/NotFoundSection.vue";
import AcreditadoSection from "@/components/AcreditadoSection.vue";
import CredencialSection from "@/components/CredencialSection.vue";
import EstudianteSection from "@/components/EstudianteSection.vue";

const routes = [
  {
    path: "/",
    component: AcreditadoSection,
  },
  {
    path: "/estudiantes",
    component: EstudianteSection,
  },
  {
    path: "/credenciales",
    component: CredencialSection,
  },
  {
    path: "/finalizado",
    name: "Finalizado",
    component: AcreditacionFinalizada,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFoundSection,
  },  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  scrollBehavior() {
    return { top: 0 }
  }
});

export default router;